import Slider from './slider';

class JdgVideo {
    constructor(params) {
        const { video } = params;

        if (!video) {
            return;
        }

        const videoPlayer = video.querySelector('.jdg-video-player');

        if (!videoPlayer) {
            return;
        }

        this.calculateProgress = this.calculateProgress.bind(this);
        this.formatTimeString = this.formatTimeString.bind(this);
        this.handleFullScreen = this.handleFullScreen.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePause = this.handlePause.bind(this);
        this.handleProgressScrub = this.handleProgressScrub.bind(this);
        this.handleVolumeScrub = this.handleVolumeScrub.bind(this);
        this.handleVolumeToggle = this.handleVolumeToggle.bind(this);
        this.toggleVolumeIcon = this.toggleVolumeIcon.bind(this);

        this.video = video;
        this.videoPlayer = videoPlayer;

        this.isPlaying = false;
        this.progress = this.video.querySelector('.jdg-video-progress');
        this.timer = this.video.querySelector('.jdg-video-timer');
        this.controlBar = this.video.querySelector('.jdg-video-controls');
        this.playBtn = this.controlBar.querySelector('.jdg-video-control--play');
        this.pauseBtn = this.controlBar.querySelector('.jdg-video-control--pause');
        this.fullscreenBtn = this.controlBar.querySelector(
            '.jdg-video-control--fullscreen'
        );
        this.volumeControl = this.controlBar.querySelector(
            '.jdg-video-control--volume'
        );

        this.volumeButton = this.volumeControl.querySelector('button');
        this.volumeRange = this.volumeControl.querySelector('input');
        this.volumeSlider = new Slider({ slider: this.volumeRange });

        this.playBtn.addEventListener('click', () => this.handlePlay());
        this.pauseBtn.addEventListener('click', () => this.handlePause());
        this.fullscreenBtn.addEventListener('click', () => this.handleFullScreen());
        this.progress.addEventListener('input', event =>
            this.handleProgressScrub(event)
        );
        this.volumeButton.addEventListener('focus', () =>
            this.volumeControl.classList.add('active')
        );
        this.volumeButton.addEventListener('focusout', () =>
            this.volumeControl.classList.remove('active')
        );
        this.volumeButton.addEventListener('mouseover', () =>
            this.volumeControl.classList.add('active')
        );
        this.volumeButton.addEventListener('mouseout', () =>
            this.volumeControl.classList.remove('active')
        );
        this.volumeRange.addEventListener('focus', () =>
            this.volumeControl.classList.add('active')
        );
        this.volumeRange.addEventListener('focusout', () =>
            this.volumeControl.classList.remove('active')
        );
        this.volumeRange.addEventListener('mouseover', () =>
            this.volumeControl.classList.add('active')
        );
        this.volumeRange.addEventListener('mouseout', () =>
            this.volumeControl.classList.remove('active')
        );
        this.volumeButton.addEventListener('click', () =>
            this.handleVolumeToggle()
        );
        this.volumeRange.addEventListener('input', event =>
            this.handleVolumeScrub(event)
        );

        this.calculateProgress();
        setInterval(this.calculateProgress, 50);
    }

    calculateProgress() {
        const currentTime = this.videoPlayer.currentTime;
        const duration = this.videoPlayer.duration;

        if (isNaN(duration)) {
            return;
        }

        this.progress.max = Math.floor(this.videoPlayer.duration);
        this.progress.value = currentTime;
        this.progress.setAttribute(
            'aria-label',
            `video time scrubber, ${this.formatTimeString(duration, true)}`
        );
        this.progress.setAttribute(
            'aria-valuetext',
            `elapsed time, ${this.formatTimeString(currentTime, true)}`
        );
        this.timer.innerHTML = `${this.formatTimeString(
            currentTime
        )} / ${this.formatTimeString(duration)}`;
    }

    formatTimeString(seconds, forScreenReader = false) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds / 60) % 60;
        const remainingSeconds = Math.floor(seconds) % 60;

        if (forScreenReader) {
            return `${hours} hours, ${minutes} minutes, ${remainingSeconds} seconds`;
        }

        const components = [hours, minutes, remainingSeconds];
        const time = components.reduce((prev, component, index, array) => {
            if (index === 0 && component === 0) {
                return prev;
            }
            if (index === 0 && component < 10) {
                return `0${component}:`;
            }
            if (index === 0) {
                return `${component}:`;
            }

            if (index === array.length - 1 && component < 10) {
                return `${prev}0${component}`;
            }
            if (index === array.length - 1) {
                return `${prev}${component}`;
            }

            if (component < 10) {
                return `${prev}0${component}:`;
            }

            return `${prev}${component}:`;
        }, '');

        return time;
    }

    handleFullScreen() {
        if (this.videoPlayer.requestFullscreen) {
            this.videoPlayer.requestFullscreen();
        } else if (this.videoPlayer.mozRequestFullScreen) {
            this.videoPlayer.mozRequestFullScreen();
        } else if (this.videoPlayer.webkitRequestFullscreen) {
            this.videoPlayer.webkitRequestFullscreen();
        } else if (this.videoPlayer.msRequestFullscreen) {
            this.videoPlayer.msRequestFullscreen();
        }
    }

    handlePlay() {
        this.isPlaying = true;
        this.videoPlayer.play();
    }

    handlePause() {
        this.isPlaying = false;
        this.videoPlayer.pause();
    }

    handleProgressScrub(event) {
        this.videoPlayer.currentTime = event.target.value;
    }

    handleVolumeScrub(event) {
        this.previousVolume = this.videoPlayer.volume;
        this.videoPlayer.volume = event.target.value / 100;
        this.toggleVolumeIcon();
    }

    handleVolumeToggle() {
        if (this.videoPlayer.volume === 0) {
            this.videoPlayer.volume = this.previousVolume;
            this.volumeRange.value = this.previousVolume * 100;
            this.toggleVolumeIcon();
            this.volumeSlider.adjustTrailWidth();

            return;
        }

        this.previousVolume = this.videoPlayer.volume;
        this.videoPlayer.volume = 0;
        this.volumeRange.value = 0;
        this.toggleVolumeIcon();
        this.volumeSlider.adjustTrailWidth();
    }

    toggleVolumeIcon() {
        const mute = this.volumeButton.querySelector('.jdg-icon--mute');
        const unmute = this.volumeButton.querySelector('.jdg-icon--unmute');

        if (this.videoPlayer.volume === 0) {
            mute.style.display = 'none';
            unmute.style.display = 'inline-block';
        } else {
            unmute.style.display = 'none';
            mute.style.display = 'inline-block';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.jdg-video');

    if (!videos) {
        return;
    }

    videos.forEach(video => new JdgVideo({ video }));
});
